import React from "react";

import TabsContext from "../tabs-context";
import TabsProvider from "../tabs-provider";

import { IProps } from "./tabs.types";

/**
 * Wrapper for a set of tabs and corresponding content.
 * @param props.activeTabId Initial tab to open.
 * @param props.children    Contents of tabs components which should include tab buttons and tab items.
 * @returns                 Tabs component.
 */
const Tabs = ({ activeTabId, children }: IProps) => (
    <div className="tabs">
        <TabsProvider activeTabId={activeTabId}>
            <TabsContext.Consumer>{() => children}</TabsContext.Consumer>
        </TabsProvider>
    </div>
);

export default Tabs;
